import { Col, Form, Input, Row } from 'antd';
import { useRouter } from 'next/router';
import { FC, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useDebouncedCallback } from 'use-debounce';
import { QuestionProps } from '../../../pages/form';
import { Core_AddressMsg } from '../../../src/generated/graphql';

const { TextArea } = Input;

export const AddressQuestion: FC<QuestionProps> = ({ question, answer, onAnswer }) => {
  const { formatMessage } = useIntl();
  const locale = useRouter().locale;

  const addressQuestion = question?.address;
  const addressAnswer = answer?.value?.address?.addressValue;

  const placeholder = formatMessage({ id: 'placeholder' });

  const [internalValue, setInternalValue] = useState<Core_AddressMsg>();

  useEffect(() => {
    if (addressAnswer !== internalValue) {
      setInternalValue(addressAnswer || undefined);
    }
  }, [addressAnswer]);

  const answerDebounced = useDebouncedCallback((value: Core_AddressMsg | undefined) => {
    onAnswer({
      address: {
        addressValue: value,
      },
    });
  }, 400);

  function onChange(newValue: Core_AddressMsg | undefined) {
    setInternalValue(newValue);

    answerDebounced(newValue);
  }

  return (
    <Row>
      <Col>
        <Form.Item label={formatMessage({ id: 'question.address.city' })}>
          <TextArea
            size={'large'}
            rows={1}
            allowClear={false}
            placeholder={placeholder}
            value={internalValue?.city ?? ''}
            onChange={(e) => {
              onChange({ ...internalValue, city: e.target.value });
            }}
          />
        </Form.Item>
        <Form.Item label={formatMessage({ id: 'question.address.street' })}>
          <TextArea
            size={'large'}
            rows={1}
            allowClear={false}
            placeholder={placeholder}
            value={internalValue?.street ?? ''}
            onChange={(e) => {
              onChange({ ...internalValue, street: e.target.value });
            }}
          />
        </Form.Item>
        <Form.Item label={formatMessage({ id: 'question.address.house-number' })}>
          <TextArea
            size={'large'}
            rows={1}
            allowClear={false}
            placeholder={placeholder}
            value={internalValue?.houseNumber ?? ''}
            onChange={(e) => {
              onChange({ ...internalValue, houseNumber: e.target.value });
            }}
          />
        </Form.Item>
        <Form.Item label={formatMessage({ id: 'question.address.zipcode' })}>
          <TextArea
            size={'large'}
            rows={1}
            allowClear={false}
            placeholder={placeholder}
            value={internalValue?.zipCode ?? ''}
            onChange={(e) => {
              onChange({ ...internalValue, zipCode: e.target.value });
            }}
          />
        </Form.Item>
      </Col>
    </Row>
  );
};
